"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 功能管理配置模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/function/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetail: function getDetail(id) {
    return (0, _request.default)({
      url: '/protected/function/query/' + id,
      method: 'get'
    });
  },
  saveItem: function saveItem(data) {
    return (0, _request.default)({
      url: '/protected/function/save',
      method: 'post',
      data: data
    });
  },
  deleteItem: function deleteItem(data) {
    return (0, _request.default)({
      url: '/protected/function/delete',
      method: 'post',
      data: data
    });
  }
};